import ApiService from "@/api/ApiService";
import { setToken } from "@/shared/api/request";
import { usePersistantStore } from "@/stores/global";
import { AddToHomeScreen, SwitchAccount } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Fragment } from "react/jsx-runtime";

export default function Impersonate({ id }: { id: number }) {
  const setAuthenticated = usePersistantStore((s) => s.setAuthenticated);

  const handleImpersonate = async (app) => {
    try {
      const answer = await ApiService.impersonate(id);

      if (app) {
        const jsonString = JSON.stringify(answer);
        const base64 = btoa(jsonString);
        if (import.meta.env.VITE_ENV_NAME !== "PROD") window.location.href = `https://apptest2.juchem-gruppe.de/#data=${base64}`;
        else window.location.href = `https://app.bob.juchem-gruppe.de/#data=${base64}`;
      } else {
        // normalize rights to string
        let rawRights = Array.isArray(answer?.rights) ? JSON.stringify(answer.rights) : answer.rights;
        if (typeof rawRights !== "string") {
          rawRights = JSON.stringify(answer.rights ?? "{}");
        }

        // store new tokens & user
        setToken(answer.token, answer.refresh_token, rawRights);
        setAuthenticated(true, answer.user.id);

        // full page load to reset any in-memory state
        window.location.href = "/";
      }
    } catch (err) {
      console.error("Impersonation failed", err);
    }
  };

  return (
    <Fragment>
      <IconButton onClick={() => handleImpersonate(false)}>
        <SwitchAccount />
      </IconButton>
      <IconButton onClick={() => handleImpersonate(true)}>
        <AddToHomeScreen />
      </IconButton>
    </Fragment>
  );
}
